import {
    formatEventStartDateAndTime,
    getAttendeeTimezone,
    getEventDatesFormat,
    getFormattedEventDate as formatEventDate,
    shouldShowDateInAttendeeTimezone,
    TimezoneLocale,
} from '@eventbrite/event-date-time';
import { getIsAppRebrandActive } from '../../selectors/app';
import { CheckoutState } from '../../state';
import { EventNamespace } from '../../state/event';
import { getIsEventOnline } from './pureSelectors';

/**
 * Selector that can be used to retrieve the full event date range string to display
 */
export const getFormattedEventDate = (state: CheckoutState) => {
    const userLocale = state.app.locale;
    const useTimezoneFrom = shouldShowDateInAttendeeTimezone({
        isOnlineEvent: getIsEventOnline(state),
        userTimezone: getAttendeeTimezone(),
    })
        ? TimezoneLocale.Attendee
        : TimezoneLocale.Creator;

    const event = state.event as EventNamespace;

    return getIsAppRebrandActive(state)
        ? formatEventStartDateAndTime({
              event,
              locale: userLocale,
              useTimezoneFrom,
          })
        : formatEventDate({
              event,
              locale: userLocale,
              datesFormat: getEventDatesFormat({
                  event,
                  locale: userLocale,
                  useTimezoneFrom,
              }),
              useTimezoneFrom,
          });
};
